import React from 'react';
import { XIcon } from 'lucide-react';
import { failedAttempts } from '../data/copy';
export function FailedAttempts() {
  return <section aria-labelledby="intentos" className="w-full border-y border-sand bg-white" data-id="element-46" data-mp="h0qvnlatizsr">
      <div className="mx-auto w-full max-w-4xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-47" data-mp="2bky01rmphmz">
        <h2 id="intentos" className="font-display text-[1.6rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.5rem]" data-id="element-48" data-mp="7aff8z9y6y4z">
          Por qué lo que ya intentaste no funcionó
        </h2>

        <ul className="mt-6 divide-y divide-sand border-t border-sand sm:mt-10" data-id="element-49" data-mp="3tk8lan9fjex6">
          {failedAttempts.map(item => <li key={item.title} className="flex gap-4 py-4 sm:gap-5 sm:py-6" data-id="element-50" data-mp="3fl8w9ei08y0h">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/10 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-51" data-mp="3ki933rmoi4sn">
                <XIcon className="h-3.5 w-3.5 text-alert sm:h-4 sm:w-4" strokeWidth={3} data-id="element-52" data-mp="1iq45q0meufaj" />
              </span>
              <div data-id="element-53" data-mp="1853s8xfysbab">
                <h3 className="text-base font-semibold text-ink sm:text-lg" data-id="element-54" data-mp="137vb906jydan">{item.title}</h3>
                <p className="mt-1 text-[0.95rem] leading-relaxed text-muted sm:text-base" data-id="element-55" data-mp="1360ywa9cjti6">
                  {item.text}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}